module.exports = __webpack_public_path__ + "img/漏损系统_xz.5b68e370.jpg";